export const FAQ: { style: any; question: string; answer: string }[] = [
  {
    style: {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
    },
    question: "What's the difference between paperwork and online forms?",
    answer:
      "For paper forms, you legibly print all form data and get a client signature on-site. For online forms, you can continually update your form fields upon login. When you need a client signature, click 'Sign and Review' to start the HelloSign process via email.",
  },
  {
    style: {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
    },
    question: "How do e-signatures work?",
    answer:
      "An e-signature is a protected and legally binding online signature, just like a handwritten signature. Although there are many online services that offer e-signatures, we use HelloSign. As noted on their website, each signature must come from a separate account. If different names were to be signed from a single HelloSign account, it would threaten the integrity of the signatures, and could potentially invalidate a document signed in this manner. To do an e-signature, one only needs to click on a HelloSign link then draw or fill out the signature field.",
  },
  {
    style: {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
    },
    question:
      "What if your system encounters an error and I lose all my data? Can you recover it? Are you liable?",
    answer:
      "We store all your data in a database on the cloud. In the very unlikely scenario that our database is compromised, we regularly create backups to ensure you still have your data. We are responsible for your data and are liable for any setbacks. Regardless, feel free to download PDF versions of your forms locally on your computer or even print them out. Stay in control of all your data.",
  },
  {
    style: {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
    },
    question:
      "I'm both an inspector and a restaurant owner. Can I do a self inspection through the online form?",
    answer:
      "Yes, just use 2 different email accounts to fill out both signature requests.",
  },
  {
    style: {
      border: "none",
    },
    question: "I'm not tech-savvy. Should I still give this a shot?",
    answer:
      "Upon successful registration, you're all set! Build your workspace and fill out your forms. Inspectinator is designed to be very user friendly. If you do encounter any problems or issues, contact us and we'll be sure to get back to you as soon as possible.",
  },
];
